export const FETCHING_ACCESSORIES_REQUESTS = '@@toyota/FETCHING_ACCESSORIES_REQUESTS';
export const FETCHED_ACCESSORIES_REQUESTS = '@@toyota/FETCHED_ACCESSORIES_REQUESTS';
export const FETCHED_ACCESSORIES_REQUESTS_FAILED = '@@toyota/FETCHED_ACCESSORIES_REQUESTS_FAILED';
export const UPDATING_ACCESSORIES_REQUESTS = '@@toyota/UPDATING_ACCESSORIES_REQUESTS';
export const UPDATED_ACCESSORIES_REQUESTS = '@@toyota/UPDATED_ACCESSORIES_REQUESTS';
export const UPDATED_ACCESSORIES_REQUESTS_FAILED = '@@toyota/UPDATED_ACCESSORIES_REQUESTS_FAILED';
export const CLEAN_ACCESSORIES_REQUESTS_LIST = '@@toyota/CLEAN_ACCESSORIES_REQUESTS_LIST';
export const FETCHING_ACCESSORIES_REQUESTS_SUMMARY = '@@toyota/FETCHING_ACCESSORIES_REQUESTS_SUMMARY';
export const FETCHED_ACCESSORIES_REQUESTS_SUMMARY = '@@toyota/FETCHED_ACCESSORIES_REQUESTS_SUMMARY';
export const FETCHED_ACCESSORIES_REQUESTS_SUMMARY_FAILED = '@@toyota/FETCHED_ACCESSORIES_REQUESTS_SUMMARY_FAILED';
